import { sendUserData } from '@/js/helpers/email-modal'
import { validateForm } from '@/js/helpers/validate-modal'
import { CustomSelect } from '@/js/vendors/custom-slect'
import { closePopup, showPopup } from '../section/popup'
import { mutationObserver } from '../helpers/mutation-observer'

const getContentByScore = (score: number, factContainer: HTMLElement | null): string | null => {
  if (!factContainer) return null
  if (score > 75) {
    return factContainer.querySelector('.high-wrapper')?.innerHTML || null
  } else if (score > 50) {
    return factContainer.querySelector('.needs-wrapper')?.innerHTML || null
  } else if (score > 25) {
    return factContainer.querySelector('.mediocre-wrapper')?.innerHTML || null
  } else {
    return factContainer.querySelector('.poor-wrapper')?.innerHTML || null
  }
}

export const setupEventListeners = (
  closePopupBtn: Element | null,
  resultPopup: Element | null,
  popupOverlay: Element | null,
  seeResultButton: Element | null
): void => {
  window.addEventListener('beforeunload', function (e: Event) {
    e.stopImmediatePropagation()
  }, true)

  if (closePopupBtn) {
    closePopupBtn.addEventListener('click', () => closePopup(resultPopup))
  }

  if (seeResultButton) {
    seeResultButton.addEventListener('click', () => showPopup(resultPopup))
  }

  if (popupOverlay) {
    popupOverlay.addEventListener('click', () => closePopup(resultPopup))
  }

  if (popupOverlay && popupOverlay.firstElementChild) {
    const child = popupOverlay.firstElementChild as HTMLElement
    child.addEventListener('click', (e: Event) => e.stopPropagation())
  }
}

const handleResultButtonClick = (
  resultButton: HTMLElement | null,
  seeResultButton: HTMLElement | null,
  factContainer: HTMLElement | null,
  restartButtonBlock: HTMLElement | null,
  restartButton: HTMLElement | null,
  resultPopup: HTMLElement | null
): void => {
  resultButton?.addEventListener('click', () => {
    const isValid = validateForm()
    if (!isValid) return
    sendUserData()
    seeResultButton?.click()
    closePopup(resultPopup)
    mutationObserver('.ays_score_percent', () => {
      const scoreQuiz = document.querySelector('.ays_score_percent')

      if (scoreQuiz) {
        const score = parseInt(scoreQuiz.textContent || '0')
        const buttonElement = factContainer?.querySelector('.btn-wrapper')?.innerHTML
        if (resultButton && buttonElement) {
          restartButton?.insertAdjacentHTML('afterend', buttonElement)
        }

        const content = getContentByScore(score, factContainer)
        if (content && restartButtonBlock) {
          restartButtonBlock.insertAdjacentHTML('beforebegin', content)
        }
      }
    })
  })
}

const setFact = (): void => {
  const seeResultButton = document.querySelector<HTMLElement>('[name="ays_finish_quiz"]')
  const parentElement = seeResultButton?.parentElement || null
  const newResultButton = document.createElement('div')

  const factContainer = document.querySelector<HTMLElement>('#tests-fact__wrapper')
  const restartButtonBlock = document.querySelector<HTMLElement>('.ays_restart_button_p')
  const restartButton = document.querySelector<HTMLElement>('.ays_restart_button')

  const closePopupBtn = document.querySelector<HTMLElement>('#close-email-popup')
  const resultPopup = document.querySelector<HTMLElement>('#email-popup')
  const popupOverlay = document.querySelector<HTMLElement>('#email-popup-overlay')
  const resultButton = document.querySelector<HTMLElement>('#email-result')

  const gradeField = document.querySelector<HTMLElement>('.grade-field')
  const selectGrade = new CustomSelect('.grade-field')

  if (gradeField) {
    const selectButton = gradeField.querySelector('.select__toggle')
    if (!selectButton) return
    selectButton.classList.add('form-field-input')
  }

  if (seeResultButton && seeResultButton.style) {
    seeResultButton.style.display = 'none'
  }

  newResultButton.textContent = 'See result'
  newResultButton.classList.add('btn')

  if (parentElement) {
    parentElement.appendChild(newResultButton)
  }

  setupEventListeners(closePopupBtn, resultPopup, popupOverlay, newResultButton)
  handleResultButtonClick(resultButton, seeResultButton, factContainer, restartButtonBlock, restartButton, resultPopup)
}

export default setFact
